// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/ContactThankyou","root":"ContactThankyou-m__root__f52bc31cEjW","recentPosts":"ContactThankyou-m__recentPosts__f52bc31MMkN"};